import type { Fetch } from '../types'

import { useSablierController } from '@/features/interface/sablier/useSablierController'

const isResponseWithoutWaitBody = (response: Response): boolean => {

  // Ne traite que les succés
  if (response.statusText !== 'OK')
    return true

  // Les statuts qui n'ont jamais de body selon la spec HTTP
  const statusCodesWithoutBody = [204, 205, 304]
  if (statusCodesWithoutBody.includes(response.status)) return true

  // Vérifie aussi le Content-Length si présent
  const contentLength = response.headers.get('Content-Length')
  return  contentLength === '0'
}

const spyBodyStream = (response: Response, onDone: () => void): Response => {
  // Gère les cas de réponses sans body (ex: 204 No Content)
  if (!response.body || isResponseWithoutWaitBody(response)) {
    onDone()
    return response
  }

  const transform = new TransformStream({ flush: onDone })
  response.body.pipeTo(transform.writable).catch(onDone) // ← erreur réseau couverte
  return new Response(transform.readable, {
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
  })
}

export function configSablier(nextFetch: Fetch): Fetch {
  const controller = useSablierController()
  return async function (input: RequestInfo | URL, init?: RequestInit) {
    // Remets directement dans le flux si le sablier n'est pas demandé
    if (!init?.sablier)
      return nextFetch(input, init)

    const timeout = (()=>{
      if (init.sablier === true) {
        controller.debutSablier()
      } else {
        if (init.sablier < 1)
          throw 'RequestInit.sablier doit être un booléen ou un entier > 0'
        return setTimeout(() => controller.debutSablier(), init.sablier)
      }
    })()

    const finSablier = () => {
      clearTimeout(timeout)
      controller.finSablier()
    }

    try {
      const response = await nextFetch(input, init)
      if (init.sablierNoWaitReadBody) {
        finSablier()
        return response
      } else {
        return spyBodyStream(response, finSablier)
      }
    } catch (error) {
      finSablier()
      throw error
    }
  }
}

